import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_ID || 'G-316S504V9P';

function gtag() {
  if (window.gtag) {
    window.gtag(...arguments);
  }
}

/**
 * Hook: tracks SPA page views on every route change.
 * Drop into any component inside <BrowserRouter>.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    gtag('config', GA_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]); // GA_ID and gtag are module-level constants
}

/**
 * Fire a custom GA4 event.
 * Usage: trackEvent('quiz_completed', { course: 'pflege', score: 85 })
 */
export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params);
}
